let focusEvents;
function focusable(container) {
  return [...container.querySelectorAll('summary, a[href], button:enabled, [tabindex]:not([tabindex^="-"]), input:not([type="hidden"]):enabled, select:enabled, textarea:enabled, iframe')]
    .filter(element => element.tabIndex >= 0 && element.getClientRects().length && !element.closest('[hidden], [inert]') && getComputedStyle(element).visibility !== 'hidden');
}
function focus(element) { element?.focus?.({ preventScroll: true }); }
export function trapFocus(container) {
  removeTrapFocus();
  focusEvents = new AbortController();
  const options = { capture: true, signal: focusEvents.signal };
  document.addEventListener('keydown', event => {
    if (event.key !== 'Tab') return;
    const items = focusable(container);
    const first = items[0], last = items.at(-1);
    if (!first) { event.preventDefault(); return; }
    const active = document.activeElement;
    if (event.shiftKey && (active === first || active === container)) { event.preventDefault(); focus(last); }
    else if (!event.shiftKey && active === last) { event.preventDefault(); focus(first); }
  }, options);
  document.addEventListener('focusin', event => {
    if (event.target instanceof Node && !container.contains(event.target)) focus(focusable(container)[0]);
  }, options);
  focus(focusable(container)[0]);
}
export function removeTrapFocus(returnTo) {
  focusEvents?.abort();
  focusEvents = undefined;
  if (returnTo?.isConnected && !returnTo.closest('[inert]')) focus(returnTo);
}
